function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.symbol.description.js";
import { createTransformer } from "mobx-utils";
const undefinedObjectSymbol = Symbol("isUndefinedObject");
class UndefinedObject {
  constructor() {
    _defineProperty(this, undefinedObjectSymbol, true);
  }
}
function isUndefinedObject(x) {
  return typeof x === "object" && undefinedObjectSymbol in x;
}
const undefinedObject = new UndefinedObject();

/**
 * This function is identical to the MobX `createTransformer` function except that it allows `undefined` to be used as a transformed value.
 * @param transformer The transformer function.
 * @param onCleanup A function called when a memoized result is no longer needed.
 */
export default function createTransformerAllowUndefined(transformer, onCleanup) {
  function unwrap(object) {
    return transformer(isUndefinedObject(object) ? undefined : object);
  }
  Object.defineProperty(unwrap, "name", {
    value: (transformer.name || "anonymous") + "-allowUndefined"
  });
  const unwrapOnCleanup = onCleanup === undefined ? undefined : function (resultObject, sourceObject) {
    const unwrapped = isUndefinedObject(sourceObject) ? undefined : sourceObject;
    return onCleanup(resultObject, unwrapped);
  };
  const transformed = createTransformer(unwrap, unwrapOnCleanup);
  return function wrap(object) {
    return transformed(object === undefined ? undefinedObject : object);
  };
}